<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>

    <hls-video ref="indexLive" :main="videoMain" />
  </div>
</template>

<script>
import inobounce from 'inobounce'
import HlsVideo from '@/components/hls-video'

export default {
  components: { HlsVideo },
  name: 'App',

  data () {
    return {
      transitionName: '',
      videoMain: true
    }
  },

  watch: {
    '$route' (to, from) {
      const nameLevel = ['room', 'coupons', 'coupon', 'coupon-product']

      // 直播间页面锁定 body
      document.body.style.height = to.name === 'room' ? '100vh' : 'auto'
      document.body.style.overflow = to.name === 'room' ? 'hidden' : 'auto'

      // 视频是否为主要
      this.videoMain = to.name === 'room'

      // iphone 回弹效果
      if (navigator.userAgent.indexOf('iPhone') > -1) {
        if (to.name === 'room') inobounce.enable()
        else inobounce.disable()
      }

      // 更新标题
      if (['coupons', 'coupon', 'coupon-product'].indexOf(from.name) !== -1 && to.name === 'room') {
        window.document.title = this.$store.state.room.name
      } else if (['coupons', 'coupon', 'coupon-product'].indexOf(from.name) !== -1) {
        window.document.title = '卡券中心'
      }
      
      // 动画效果
      const toDepth = nameLevel.findIndex(item => item === to.name)
      const fromDepth = nameLevel.findIndex(item => item === from.name)

      if (fromDepth == -1 || toDepth == fromDepth) return

      this.transitionName = toDepth > fromDepth ? 'slide-left' : 'slide-right'
    }
  }
}
</script>

<style lang="scss">
@import 'styles/index.scss';
@import 'styles/vant.scss';

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 400ms;
  position: absolute;
}
 
.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}
 
.slide-right-leave-active {
  opacity: 0;
  transform: translateX(100%);
}
 
.slide-left-enter {
  opacity: 0;
  transform: translateX(100%);
}
 
.slide-left-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}

</style>
